export class AppConsts {

    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'Paranet'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token'
    };

    static maxResultsCount = 2147483647;
    static paraguayCountryCode = 'PRY';
    static usaCountryCode = 'USA';
    static paraguayCurrencyCode = 'PYG';
    static dateTimeFormat = 'yyyy-MM-dd HH:mm';
    static dateFormat = 'yyyy-MM-dd';
}
